import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Container, Grid, TextField, Button, Snackbar, Typography } from '@material-ui/core/';
import { recoverPassword } from '../actions/auth';
import MySnackbarContentWrapper from './AppSnackbar';
import { mobileCheck } from '../utils/mobileCheck';
import Logo from "../assets/logo.png";

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  paper: {
    padding: theme.spacing(2),
  },
  container: {
    padding: theme.spacing(mobileCheck() ? 0 : 4),
  },
  grid: {
    margin: '10px',
    width: '100%',
  },
  textField: {
    width: '100%',
  },
  button: {
    margin: theme.spacing(1),
  },
  typography: {
    margin: theme.spacing(1),
    textAlign: 'center',
    width: '100%',
  },
  img: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '500px',
    paddingTop: '20px',
    paddingBottom: '10px',
  },
}));

export default function RecoverPasswordView(props) {
  const classes = useStyles();

  const [values, setValues] = React.useState({
    username: '',
  });

  const [snack, setSnack] = React.useState({
    open: false,
    text: "Snack text",
    variant: "error",
  })

  useEffect(() => {
  }, []);

  function openSnack(message, variant) {
    setSnack({ ...snack, open: true, text: message, variant: variant });
  }

  function handleSnackClose() {
    setSnack({ ...snack, open: false });
  }

  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
  };

  const onRecovery = async () => {
    const result = await recoverPassword(values.username);

    if (!result.success) {
      openSnack(result.message.error, 'error');
      return;
    }

    openSnack('El mail ha sido enviado', 'success');
  };

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.grid}>
            <img className={classes.img} src={Logo} alt="Logo" />
        </Grid>
        <Grid item xs={!mobileCheck() ? 3 : 2} />
        <Grid item xs={!mobileCheck() ? 6 : 8}>
          <Paper className={classes.paper}>
            <Typography variant="h6" className={classes.typography}>
              Recuperar contraseña
            </Typography>
            <Grid container>
              <Grid item xs={12} className={classes.grid}>
                <TextField
                  label="Nombre Usuario"
                  className={classes.textField}
                  id="standard-password-input"
                  onChange={handleChange('username')}
                  value={values.username}
                />
              </Grid>
              <Grid item xs={12}><br /></Grid>
              <Grid item xs={12}><br /></Grid>
              <Grid item xs={7} />
              <Grid item >
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={onRecovery}
                >
                  Recuperar
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={snack.open}
        autoHideDuration={6000}
        onClose={handleSnackClose}
      >
        <MySnackbarContentWrapper
          onClose={handleSnackClose}
          variant={snack.variant}
          message={snack.text}
        />
      </Snackbar>
    </Container>

  );
}
